import { lazy } from 'react';
import { Route } from 'react-router-dom';

const SurveyStartNew = lazy(() => import('../components/survey/startScreen/index2.jsx'));
const Survey = lazy(() => import('../components/survey/index.js'));

const surveyRoutes = (
	<>
		<Route path="/surveyStartNew" element={<SurveyStartNew />} />
		<Route path="/survey" element={<Survey />} />
	</>
);

export default surveyRoutes;
